<script>
export default {
  name: "DeviceDashboardCard",
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    loading: Boolean
  },
  computed: {
    getTitle() {
      return this.title ?? this.$t('common.devices');
    },
    getSubtitle() {
      return this.subtitle ?? this.$t('common.total');
    }
  },
}
</script>

<template>
  <Card class="relative">
    <template #title>{{ getTitle }}</template>
    <template #subtitle>{{ getSubtitle }}</template>
    <template #content>

      <div v-if="loading" class="z-10 absolute inset-0 bg-surface-0/95 rounded-md flex items-center justify-center">
        <ProgressSpinner/>
      </div>

      <div class="flex flex-col flex-1 justify-end -mt-4" :class="{'opacity-0': loading}">
        <slot>
          <span class="text-4xl font-extrabold text-surface-700 block">
            {{ value?.toLocaleString() || 0 }}
          </span>
        </slot>
      </div>
    </template>

    <template v-if="$slots.footer" #footer>
      <slot name="footer"></slot>
    </template>
  </Card>

</template>

<style scoped>

</style>
